<template>
    <table cellpadding="0" cellspacing="0" border="0" class="boite" style="border-spacing:0px;">
        <tbody>
            <tr style="font-size: 0px;">
                <td>
                    <img src="@/assets/img/bordure_haut_gauche.jpg">
                </td>
                <td>
                    <img src="@/assets/img/bordure_haut_centre.jpg">
                </td>
                <td>
                    <img src="@/assets/img/bordure_haut_droite.jpg">
                </td>
            </tr>
            <tr>
                <td :style="{ backgroundImage : 'url(' + require('@/assets/img/bordure_gauche.jpg') + ')' }">
                </td>
                <td>
                    <slot></slot>
                </td>
                <td :style="{ backgroundImage : 'url(' + require('@/assets/img/bordure_droite.jpg') + ')' }">
                </td>
            </tr>
            <tr>
                <td>
                    <img src="@/assets/img/bordure_bas_gauche.jpg">
                </td>
                <td>
                    <img src="@/assets/img/bordure_bas_centre.jpg">
                </td>
                <td>
                    <img src="@/assets/img/bordure_bas_droite.jpg">
                </td>
            </tr>
        </tbody>
    </table>
</template>


<script>
    
export default {
    data() {
        return {
        }
    }
}

</script>




// WEBPACK FOOTER //
// src/components/Frame.vue